import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Box } from '@mui/material';
import { LoadPanel } from 'devextreme-react/load-panel';

import { IAvailableClientsResults } from 'interfaces/HistoricalResults/IAvailableClientsResults';
import { HistoricalResultsApis } from 'hooks/apis/HistoricalResultsApis';
import AvailableResultsGrid from '../AvailableResultsGrid/AvailableResultsGrid';

const AvailableClientResults = () => {
  const { getAvailableClientResults } = HistoricalResultsApis();
  const [availableClientResults, setAvailableClientResults] = useState<IAvailableClientsResults[]>(null);
  const [apiMessage, setApiMessage] = useState<string>(null);
  const [dataLoading, setDataLoading] = useState(true);

  useEffect(() => {
    getAvailableClientResults().then((data) => {
      if (!data.message) {
        setAvailableClientResults(data);
      } else {
        setApiMessage(data.message);
      }
      setDataLoading(false);
    });
  }, [getAvailableClientResults]);

  return (
    <Box>
      <LoadPanel height={100} width={250} message="Loading Client Results" visible={dataLoading} />

      {apiMessage ? <Box className="errorBox">{apiMessage}</Box> : null}

      {!dataLoading && availableClientResults?.length === 0 ? (
        <Box>
          No client data available, request access in your <Link to="/profile">Profile</Link>
        </Box>
      ) : (
        availableClientResults?.map((m) => (
          <Box key={`${m.ClientName}-${m.EnvirolabBranch}`} className="resultsBox">
            <h2>
              {m.ClientName} | {m.EnvirolabBranch} {m.EnvirolabBranch === "Perth" || m.EnvirolabBranch === "Melbourne" ? <span className='historicalText'> - Historical</span> : null}
            </h2>
            <p>{m.Address}</p>

            <AvailableResultsGrid results={m.AvailableResults} />
          </Box>
        ))
      )}
    </Box>
  );
};

export default AvailableClientResults;
